import React from 'react';
import {
  Grid,
  Form,
  FormBody,
  FormFooter,
  FormGroup,
  Label,
  LabelText,
  InputMessage,
  InputAddonNumberControls,
  useUpDownNumberControl,
  Input,
  Button,
  LoadingOr,
  InfoBox,
  themeUtils as tu,
} from '@zen-common/components-base';
import { FpUtils } from '@zen/common-app-parts';
import _oracles from '../../utils/oracles';
import OraclesDropDownFG from '../../components/form/edit/OraclesDropDownFG';

const oracles = _oracles.map((o) => ({ label: `${o.chain} ${o.address}`, value: o.address }));

/**
 * A form for issue and cancel
 * @param {Object} props
 * @param {Function} props.onSubmit
 * @param {import('../../stores/FixedPayoutStore').RedeemStore} props.store
 */
export default function RedeemForm({ onSubmit, store, naming }) {
  const {
    actions,
    state: { oracle, asset1, amount1, valid: formValid, progress },
  } = store;

  const setOracle = (item) => {
    actions.setOracle(_oracles.find((o) => o.address === item.value) || null);
  };
  const reset = () => {
    actions.reset();
  };

  const amount1KeyHandler = useUpDownNumberControl({
    min: 0,
    value: amount1.value.safeValue,
    onChange: actions.setAmount1,
  });

  const isMobile = document.body.clientWidth < tu.breakpoints.xl.replace('px', '');

  const resetDisabled = React.useMemo(() => asset1.value === '' && amount1.value.value === '', [
    amount1.value.value,
    asset1.value,
  ]);

  return (
    <Form onSubmit={onSubmit} disabled={progress}>
      <FormBody>
        <OraclesDropDownFG items={oracles} value={oracle} onChange={setOracle} />

        <Grid.Row>
          <Grid.Col50>
            <FormGroup>
              <InfoBox info="Bull/Bear" isMobile={isMobile}>
                <Label htmlFor="redeem-form-asset1">
                  <LabelText>
                    {FpUtils.getTitle({ asset: asset1.value, title: 'Asset', naming })}
                  </LabelText>
                </Label>
              </InfoBox>
              <Input
                id="redeem-form-asset1"
                inputType="input"
                variant="block"
                value={asset1.value}
                valid={asset1.value ? asset1.valid : undefined}
                onChange={(e) => actions.setAsset1(e.target.value.trim())}
                disabled={progress}
              />
              <InputMessage>{asset1.value && !asset1.valid && 'Invalid asset'}</InputMessage>
            </FormGroup>
          </Grid.Col50>
          <Grid.Col50>
            <FormGroup>
              <Label htmlFor="redeem-form-amount1">
                <LabelText>Amount</LabelText>
              </Label>
              <Input
                id="redeem-form-amount1"
                inputType="input"
                variant="block"
                disabled={progress}
                value={amount1.value.display}
                onChange={(e) => actions.setAmount1(e.target.value.trim())}
                valid={amount1.value.display ? amount1.valid : undefined}
                renderRightAddon={
                  <InputAddonNumberControls
                    onChange={actions.setAmount1}
                    value={amount1.value.safeValue}
                    min="0"
                  />
                }
                {...amount1KeyHandler}
              />
              <InputMessage>
                {amount1.value.display && !amount1.valid && 'Invalid amount'}
              </InputMessage>
            </FormGroup>
          </Grid.Col50>
        </Grid.Row>

        <FormFooter>
          <Button bg="secondary" onClick={reset} disabled={resetDisabled}>
            Reset
          </Button>
          <Button type="submit" disabled={!formValid}>
            <LoadingOr loading={progress}>Generate</LoadingOr>
          </Button>
        </FormFooter>
      </FormBody>
    </Form>
  );
}
